define((require) => {
    'use strict';

    const toolkit = require('toolkit/b-toolkit/b-toolkit');

    return toolkit.create('billing-registration__empty-suggest', {});
});
